export const SI = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_15736)">
      <g clipPath="url(#clip1_1073_15736)">
      <rect x="96" y="64" width="96" height="32" transform="rotate(180 96 64)" fill="#0066FF"/>
      <rect x="96" y="32" width="96" height="32" transform="rotate(180 96 32)" fill="white"/>
      <rect x="96" y="96" width="96" height="32" transform="rotate(180 96 96)" fill="#EF4444"/>
      <circle cx="28" cy="32" r="12" fill="#0066FF"/>
      <path d="M28 44C34.6274 44 40 38.6274 40 32H16C16 38.6274 21.3726 44 28 44Z" fill="white"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_15736">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_15736">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
